<template>
  <div class="app-main__inner">
    <TituloComponent
      icono-titulo="fas fa-pencil-alt"
      texto-titulo="Editar Regimen"
    ></TituloComponent>
    <div class="main-card mb-3 card col-12 col-md-8 offset-md-2">
      <div class="card-body">
        <form @submit.prevent="guardarRegimenJubilatorio()">
          <float-label label="Código:" clase>
            <input
              v-model="regimenJubilatorio.codigo"
              id="codigo"
              placeholder="Ingresar un código..."
              type="text"
              class="form-control"
              :class="
                enviado && !$v.regimenJubilatorio.codigo.required
                  ? 'is-invalid'
                  : ''
              "
            />
            <template v-slot:validation>
              <div
                class="invalid-feedback"
                v-if="enviado && !$v.regimenJubilatorio.codigo.required"
              >
                Debe ingresar un código
              </div>
            </template>
          </float-label>
          <float-label label="Descripción:" clase>
            <input
              v-model="regimenJubilatorio.descripcion"
              id="descripcion"
              placeholder="Ingresar una descripción..."
              type="text"
              class="form-control"
              :class="
                enviado && !$v.regimenJubilatorio.descripcion.required
                  ? 'is-invalid'
                  : ''
              "
            />
            <template v-slot:validation>
              <div
                class="invalid-feedback"
                v-if="enviado && !$v.regimenJubilatorio.descripcion.required"
              >
                Debe ingresar una descripción
              </div>
            </template>
          </float-label>
          <button class="mt-1 btn btn-info float-right">Guardar</button>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import TituloComponent from "@/components/layouts/TituloComponente";

import FloatLabel from "@/components/layouts/FloatLabel";
import { required } from "vuelidate/lib/validators";
import axios from "axios";
import Swal from "sweetalert2";
import RegimenJubilatorio from "@/models/regimenJubilatorio";
export default {
  name: "EditarRegimenJubilatorio",
  components: {
    TituloComponent,
    FloatLabel,
  },
  data() {
    return {
      regimenJubilatorio: new RegimenJubilatorio(null, "", ""),
      loading: false,
      enviado: false,
    };
  },
  validations: {
    regimenJubilatorio: {
      codigo: { required },
      descripcion: { required },
    },
  },
  mounted() {
    this.regimenJubilatorio.id = this.$route.params.id;
    this.getRegimenJubilatorio();
  },
  methods: {
    getRegimenJubilatorio() {
      this.loading = true;
      axios
        .get("regimenjubilatorio/" + this.regimenJubilatorio.id)
        .then((res) => {
          console.log(res.data);
          if (res.data.success) {
            this.regimenJubilatorio = res.data.regimenjubilatorio;
          }
        })
        .catch(() => {
          Swal.fire({
            icon: "warning",
            title: "Oopss..",
            text: `No se ha encontrado regimen jubilatorio.`,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    guardarRegimenJubilatorio() {
      this.enviado = true;
      this.loading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.loading = false;
        return false;
      }
      axios
        .put(
          "/regimenjubilatorio/" + this.regimenJubilatorio.id,
          this.regimenJubilatorio
        )
        .then((res) => {
          if (res.data.success) {
            Swal.fire({
              icon: "success",
              title: "Éxito",
              text: `${res.data.regimenjubilatorio.descripcion} se editó con éxito.`,
            });
            this.$router.push({ name: "ListarRegimenJubilatorio" });
          }
        })
        .catch((error) => {
          console.log(error);
          Swal.fire({
            icon: "error",
            title: "Oopss..",
            text: `No se ha podido completar la operación.`,
          });
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>